"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sortRowTree = void 0;
var _xDataGrid = require("@mui/x-data-grid");
// Single-linked list node
var Node = /*#__PURE__*/ function() {
    function Node(data, next) {
        _class_call_check(this, Node);
        this.next = void 0;
        this.data = void 0;
        this.next = next;
        this.data = data;
    }
    _create_class(Node, [
        {
            key: "insertAfter",
            value: function insertAfter(list) {
                if (!list.first || !list.last) {
                    return;
                }
                var next = this.next;
                this.next = list.first;
                list.last.next = next;
            }
        }
    ]);
    return Node;
}();
// Single-linked list container
var List = /*#__PURE__*/ function() {
    function List(first, last) {
        _class_call_check(this, List);
        this.first = void 0;
        this.last = void 0;
        this.first = first;
        this.last = last;
    }
    _create_class(List, [
        {
            key: "data",
            value: function data() {
                var array = [];
                this.forEach(function(node) {
                    array.push(node.data);
                });
                return array;
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var current = this.first;
                while(current !== null){
                    fn(current);
                    current = current.next;
                }
            }
        }
    ], [
        {
            key: "from",
            value: function from(array) {
                if (array.length === 0) {
                    return new List(null, null);
                }
                var index = 0;
                var first = new Node(array[index], null);
                var current = first;
                while(index + 1 < array.length){
                    index += 1;
                    var node = new Node(array[index], null);
                    current.next = node;
                    current = node;
                }
                return new List(first, current);
            }
        }
    ]);
    return List;
}();
var sortRowTree = function(params) {
    var rowTree = params.rowTree, disableChildrenSorting = params.disableChildrenSorting, sortRowList = params.sortRowList, shouldRenderGroupBelowLeaves = params.shouldRenderGroupBelowLeaves;
    var sortedGroupedByParentRows = new Map();
    var sortGroup = function(node) {
        var shouldSortGroup = !!sortRowList && (!disableChildrenSorting || node.depth === -1);
        var sortedRowIds;
        if (shouldSortGroup) {
            for(var i = 0; i < node.children.length; i += 1){
                var childNode = rowTree[node.children[i]];
                if (childNode.type === 'group') {
                    sortGroup(childNode);
                }
            }
            sortedRowIds = sortRowList(node.children.map(function(childId) {
                return rowTree[childId];
            }));
        } else if (shouldRenderGroupBelowLeaves) {
            var childrenLeaves = [];
            var childrenGroups = [];
            for(var i1 = 0; i1 < node.children.length; i1 += 1){
                var childId = node.children[i1];
                var childNode1 = rowTree[childId];
                if (childNode1.type === 'group') {
                    sortGroup(childNode1);
                    childrenGroups.push(childId);
                } else if (childNode1.type === 'leaf') {
                    childrenLeaves.push(childId);
                }
            }
            sortedRowIds = _to_consumable_array(childrenLeaves).concat(_to_consumable_array(childrenGroups));
        } else {
            for(var i2 = 0; i2 < node.children.length; i2 += 1){
                var childNode2 = rowTree[node.children[i2]];
                if (childNode2.type === 'group') {
                    sortGroup(childNode2);
                }
            }
            sortedRowIds = _to_consumable_array(node.children);
        }
        if (node.footerId != null) {
            sortedRowIds.push(node.footerId);
        }
        sortedGroupedByParentRows.set(node.id, sortedRowIds);
    };
    sortGroup(rowTree[_xDataGrid.GRID_ROOT_GROUP_ID]);
    var rootList = List.from(sortedGroupedByParentRows.get(_xDataGrid.GRID_ROOT_GROUP_ID));
    rootList.forEach(function(node) {
        var children = sortedGroupedByParentRows.get(node.data);
        if (children === null || children === void 0 ? void 0 : children.length) {
            node.insertAfter(List.from(children));
        }
    });
    return rootList.data();
};
exports.sortRowTree = sortRowTree;
